module.exports = __webpack_public_path__ + "img/crafted.30d63ed1.png";